import $ from 'jquery';
import intlTelInput from "intl-tel-input";
import Stepper from "bs-stepper";
import 'slick-carousel';
import ContentTile from "../../classes/ContentTile";
//import LazyLoad from "vanilla-lazyload";
let LazyLoad = require("vanilla-lazyload");
let Search = require('./search');
let Slider = require('./slider');
let FeaturedContent = require('../v2/featured_content');

const humanizeDuration = require("humanize-duration");
const shortEnglishHumanizer = humanizeDuration.humanizer({
    language: "shortEn",
    languages: {
        shortEn: {
            y: () => "y",
            mo: () => "mo",
            w: () => "w",
            d: () => "d",
            h: () => "h",
            m: () => "m",
            s: () => "s",
            ms: () => "ms",
        },
    },
});

export function removeProvenanceFromUrl() {
    const url = new URL(window.location.href);
    url.searchParams.delete('provenance');
    window.history.replaceState(null, '', url.toString());
}

export function declareGlobalVariables(){
    window.smart_scroll_ready = false;
    window.display_loaded_series = window.location.search.includes("display_loaded_series=true");
    window.body_data = $("body").data();
    window.is_home_page = location.pathname == "/" || (window.body_data['controllerClass'] == 'Web::V1::PagesController' && window.body_data["actionName"] == 'home');
    window.is_my_list_page = window.body_data['controllerClass'] == 'Web::V1::PagesController' && window.body_data["actionName"] == 'my_list';
    window.is_movie_details_page = window.body_data['controllerClass'] == 'Web::V1::MoviesController' && window.body_data["actionName"] == 'show';
    window.is_user_account_page = window.body_data['controllerClass'] == 'Web::V1::UsersController' && window.body_data["actionName"] == 'show';
    window.is_terms_page = window.body_data['controllerClass'] == 'Web::V1::PagesController' && window.body_data["actionName"] == 'terms';
    window.is_privacy_page = window.body_data['controllerClass'] == 'Web::V1::PagesController' && window.body_data["actionName"] == 'privacy';
    window.is_checkout_page = window.body_data['controllerClass'] == 'Web::V1::CheckoutController' && window.body_data["actionName"] == 'index';
    window.catalog_request_ready = window.catalog_request && window.catalog_request['data'] && window.catalog_request['data'].length > 0;
    window.is_profile_edit_page = window.body_data['controllerClass'] == 'Web::V1::ProfilesController' && window.body_data["actionName"] == 'edit';
    window.is_category_page = window.body_data['controllerClass'] == 'Web::V1::CategoriesController' && window.body_data["actionName"] == 'show';
    window.is_movie_list_page = window.body_data['controllerClass'] == 'Web::V1::MoviesController' && window.body_data["actionName"] == 'index';
    window.is_subseries_list_page = window.body_data['controllerClass'] == 'Web::V1::SeriesController' && window.body_data["actionName"] == 'index';
    window.is_search_page = window.body_data['controllerClass'] == 'Web::V1::PagesController' && window.body_data["actionName"] == 'search';
    window.is_content_page = window.is_home_page || window.is_category_page || window.is_movie_details_page || window.is_movie_list_page || window.is_subseries_list_page || window.is_movie_list_page || window.is_search_page || window.is_my_list_page;
}

export function initHome() {
    $(document).scroll(function () {
        let $nav = $(".navbar-fixed-top");
        let $jumbotron = $("#jumbotron-content");
        let scroll_limit = $jumbotron.height() / 2;
        $nav.toggleClass('scrolled', $(this).scrollTop() > scroll_limit);
    });


    $(window).scroll(function() {
        let window_bottom = $(this).scrollTop() + $(this).innerHeight();
        $(".scroll-fade-temp").each(function() {
            let not_first_series = window.first_series_id != this.id;
            let series_not_displayed = !window.series_displayed.includes(this.id);
            let series =  $(this).outerHeight();
            let quarter_series = series / 4;
            let object_bottom = $(this).offset().top + quarter_series;
            if (object_bottom < window_bottom) {
                if ($(this).css("opacity")==0) {
                    $(this).fadeTo(1000,1);
                    if (!window.series_displayed.includes(this.id)) {
                        window.series_displayed.push(this.id);
                    }
                }
            } else {
                if ($(this).css("opacity")==1 && not_first_series && series_not_displayed) {
                    $(this).fadeTo(250,0);
                }
            }
        });
    }).scroll();

    if(window.display_catalog) {
        displayModalMessage(
            "Loaded catalog " + window.catalog_id,
            'success',
            4000
        );
    }
}

export function initMovieDetails() {
    if(window.signed_in) {
        if (window.open_tvod) {
            let tvod_link = document.getElementById('tvod_link_' + window.open_tvod);
            if (tvod_link) {
                let data = $(tvod_link).data();
                $(tvod_link).click();
                toggleTvodPurchaseItems(data['type'], data['amount']);
            } else {
                let play_link = document.getElementById('play_link');
                let resume_link = document.getElementById('resume_link');
                if (play_link || resume_link) {
                    displayModalMessage(
                        'You already have a purchase for this movie!',
                        'success',
                        3000
                    );
                } else {
                    displayModalMessage(
                        "You don't have access to this movie",
                        'danger',
                        3000
                    );
                }
            }
        }
    }

    $('.confirm-purchase').click(function() {
        $('#purchase_pin_code').val('');
        let data = $(this).data();
        if(data['type']) {
            toggleTvodPurchaseItems(data['type'], data['amount']);
        }

        let tvod_redirect_link = document.getElementById('tvod_purchase_redirect')
        if (tvod_redirect_link && data['link']) {
            $(tvod_redirect_link).attr("href", data['link'])
        }

        if(window.stepper) {
            toStep($('#recurly_payment_form'), 1);
        }
    });
}

export function initMovieDetailsPost() {
    if (window.subseries_id) {
        let subseries_index_options = {
            endpoint: 'subseries',
            id: window.subseries_id,
            page: 1,
            index_start: 0,
            hideSeriesName: true
        };
        getCatalogPage(subseries_index_options);
    }

    if (window.catalog_request_ready) {
        insertSuggestionsSlider(true);
    } else {
        let similar_recommendations_options = {
            endpoint: 'similar-items',
            id: window.recommendation_id,
            kind: window.recommendation_kind,
            page: 1,
            index_start: 0
        };
        getCatalogPage(similar_recommendations_options);
    }
}

export function toggleTvodPurchaseItems(transaction_type, amount) {
    $('#transaction_type').val(transaction_type);
    $('.tvod-transaction-type').html(transaction_type);
    $('.tvod-amount').html(amount);

    let $buy_info = $('.buy-info');
    let $rent_info = $('.rent-info');
    switch (transaction_type) {
        case 'buy':
            $rent_info.hide();
            $buy_info.show();
            break;
        case 'rent':
            $buy_info.hide();
            $rent_info.show();
            break;
        default:
            break;
    }
}

export function initMyList() {
    let user_recommendations_options = { endpoint: 'user-recommendations', page: 1, index_start: 0 };
    getCatalogPage(user_recommendations_options);
}

export function initStepper() {
    let steppers = $('.bs-stepper');
    window.stepper = {};
    if(steppers.length > 0) {
        $.each(steppers, function (index, stepper_obj) {
            try{
                // There are some issues with this and it needs a deeper review
                // Cancellations Stepper initialized by app/javascript/scripts/web/v1/users/cancel_subscription.js
                let data = $(stepper_obj).data();
                let stepper_options = {}

                stepper_options.linear = data.linear ? true : false;
                stepper_options.animation = data.animation ? true : false;

                window.stepper[stepper_obj.id] = new Stepper(stepper_obj, stepper_options);
            } catch (e) {
                console.log("there is been an error initializing stepper");
                console.log(stepper_obj);
                console.log(e);
            }
        });

        $('.stepper-next').click(function() {
            nextStep(this);
        });

        $('.pin-next').hide();

        $('.pin-next').click(function() {
            nextStep(this);
        });
    }
}

function nextStep(that) {
    let $closest_stepper = $(that).closest('div.bs-stepper');
    window.stepper[$closest_stepper.attr('id')].next();
}

function toStep(that, step_number) {
    let $closest_stepper = $(that).closest('div.bs-stepper');
    let stepper = window.stepper[$closest_stepper.attr('id')];
    if(stepper) {
        stepper.to(step_number);
    }
}

export function initTogglePasswordField() {
    $(".input-group-text-lsi a").on('click', function (event) {
        event.preventDefault();
        togglePasswordField(this);
    });

    $(".input-group-reveal a").on('click', function (event) {
        event.preventDefault();
        togglePasswordField(this, false, { on: window.localized_text.hide, off: window.localized_text.show });
    });
}
export function insertSuggestionsSlider(separate_kind) {
    populateSeries(window.catalog_request['data'][0], 1, null, null, false, separate_kind);
    $('.series-1-0 div').removeClass('scroll-fade');
}

export function insertSuggestionsGrid() {
    populateSeries(window.catalog_request['data'][0], 1, null, null, true, false);
    $('.series-1-0 div').removeClass('scroll-fade');
    $('.series-name').hide();
}

export function loadContentPre() {
    if ( window.catalog_request) {
        try {
            let data = window.catalog_request.data;
            if (data) {
                series_options.page = 1;
                displayLoadedSeriesNotification('catalog page ' + series_options.page);
                for(let i=0; i < data.length; i++) {
                    let index = i;
                    populateSeries(data[i], series_options.page, null, index, false, false);
                    if(window.is_checkout_page) {
                        break;
                    }
                }
                registerLoadedPage(series_options.page);
            }

            if(!window.is_checkout_page) {
                setTimeout(function () {
                    displayLoadedSeriesNotification('top content');
                    let top_content_options = { endpoint: 'top-content', page: series_options.page, index_start: 0 };
                    getCatalogPage(top_content_options);
                }, 1000);
            }
        } catch (e) {
            console.error(e)
        }
    }
}

export function loadContentPost() {
    setTimeout(function () {
        displayLoadedSeriesNotification('active purchases');
        let active_purchases_options = { endpoint: 'active-purchases', page: 1, index_start: 0 };
        getCatalogPage(active_purchases_options);
    }, 1000);


    setTimeout(function () {
        displayLoadedSeriesNotification('recommendations');
        let user_recommendations_options = { endpoint: 'user-recommendations', page: 1, index_start: 0 };
        getCatalogPage(user_recommendations_options);
    }, 2000);

    setTimeout(function () {
        displayLoadedSeriesNotification('because you watched');
        let because_user_watched_options = { endpoint: 'because-user-watched', page: 1, index_start: 0 };
        getCatalogPage(because_user_watched_options);
    }, 3000);
}

export function getCatalogPage(options) {
    let url = urlFromEndpoint(options);
    $.getJSON(url, function (data) {
            if (data) {
                let series = seriesFromEndpoint(options.endpoint, data);
                if (series.length > 0) {
                    try {
                        for(let i=0; i < series.length; i++) {
                            let index = i;
                            let my_list_recommendations = window.is_my_list_page && options.endpoint == "user-recommendations";
                            populateSeries(series[i], options.page, options.endpoint, index, my_list_recommendations, false);
                            if(my_list_recommendations) {
                                break;
                            }
                        }

                        if(window.is_movie_details_page || window.is_my_list_page) {
                            $('.spinner-lsi').hide();
                        }

                        if (!options.endpoint) {
                            registerLoadedPage(options.page);
                        }

                        if (options.hideSeriesName) {
                            $('.series-name').hide();
                        }
                    } catch (e) {
                        console.error(e)
                    }
                } else {
                    if(window.is_movie_details_page || window.is_my_list_page) {
                        switch (options.endpoint) {
                            case 'subseries':
                                $('#episodes-tab').hide();
                                break;
                            case 'similar-items':
                                $('#suggested-tab').hide();
                                break;
                            default:
                                break;
                        }

                        $('.spinner-lsi').hide();
                    }
                }
            }
        }
    );
}

function seriesFromEndpoint(endpoint, data) {
    switch(endpoint) {
        case "search":
        case 'details':
        case "active-purchases":
        case "top-content":
        case "user-recommendations":
        case "because-user-watched":
        case "similar-items":
            return data;
        case "subseries":
            console.log(endpoint);
            let new_data = data['data'];
            let sorted_data = new_data.sort((a, b) => (a.sort_order > b.sort_order) ? 1 : -1 );
            return sorted_data;
        default:
            console.log(endpoint);
            return data['data'];

    }
}

export function urlFromEndpoint(options) {
    let url = "/api/v4/movies/personalized_movie_index/";
    switch (options.endpoint) {
        case "search":
            url += options.endpoint;
            url += "?simplified=true";
            url += '&template=search';
            break;
        case 'details':
            url = '/' + options.kind.replace("sub", "");
            url += '/' + options.id;
            break;
        case "similar-items":
            url += options.endpoint.split('-').join('_');
            url += "?simplified=true";
            url += "&id=" + options.id;
            url += "&kind=" + options.kind;
            url += '&template=web';
            break;
        case "active-purchases":
        case "top-content":
        case "user-recommendations":
        case "because-user-watched":
            url += options.endpoint.split('-').join('_');
            url += "?simplified=true";
            url += '&template=web';
            break;
        case 'subseries':
            url += 'subseries/' + options.id;
            url += "?simplified=true";
            url += "&resume_time=true";
            if (!window.signed_in) {
                url += "&unauthenticated_preview=true";
            }
            break;
        default:
            url += "?page=" + options.page;
            url += "&page_size=" + options.page_size;
            url += "&simplified=true";
            url += '&template=web';
            break;
    }

    return url;
}

export function urlFromKind(kind, id, endpoint) {
    let url;
    if(endpoint == 'subseries') {
        url = '/movies/' + id + '/play';
    } else {
        switch(kind) {
            case "movie":
                url = '/movies/' + id;
                break;
            case "subseries":
                url = '/series/' + id;
                break;
            case "audio":
                url = '/music/'+ id ;
                break;
            default:
                url = null;
                break;
        }
    }


    return url;
}

export function populateSeries(data, page, endpoint, index, is_grid, separate_kind) {
    if(data) {
        let content_id;
        if(endpoint != 'subseries') {
            content_id = 'series';
        } else{
            content_id = endpoint;
        }
        content_id += '-' + data['sort_order'];

        let series_id = string_parameterize(data.series) + '-' + data.id;
        let movies = data.movies ? data.movies : [];
        let subseries = data.subseries ? data.subseries : [];
        if(separate_kind) {
            movies =  sortAndFilterUnique(movies);
            processSeriesToDisplay(data, page, movies, series_id, content_id, endpoint, index, is_grid, 'Movies');
            subseries = sortAndFilterUnique(subseries);
            processSeriesToDisplay(data, page, subseries, series_id, content_id, endpoint, index, is_grid, 'Series');
        } else {
            let series_items = sortAndFilterUnique( movies.concat(subseries) );
            processSeriesToDisplay(data, page, series_items, series_id, content_id, endpoint, index, is_grid, false);
        }
    }
}

export function processSeriesToDisplay(data, page, series_items, series_id, content_id, endpoint, index, is_grid, alternative_series_name) {
    if (series_items.length > 0) {
        let content = getSeriesContainerById(content_id);
        if(content) {
            if(is_grid) {
                let grid = createSeriesGrid(data, series_items, endpoint);
                content.appendChild(grid);
            } else {
                let slider = createSeriesSlider(data, series_items, endpoint, alternative_series_name);
                content.appendChild(slider);
                let insert_loader_marker = !endpoint && index && window.catalog_loader_index && index == window.catalog_loader_index;
                if (insert_loader_marker) {
                    let next_page = parseInt(page) + 1;
                    if (next_page <= window.catalog_page_count) {
                        let loader_marker = document.createElement('div');
                        loader_marker.id = 'series-loader-' + next_page;
                        loader_marker.dataset.page = next_page;
                        loader_marker.className = "series-scroll-loader";
                        content.appendChild(loader_marker);
                    }
                }
                if ( !window.first_series_id ) {
                    window.first_series_id = series_id;
                }

                registerLoadedSeries();
            }
        } else {
            console.log("ERROR: couldn't find container " + content_id);
        }
    }
}

export function getSeriesContainerById(id) {
    let container = document.getElementById(id);
    if(!container) {
        let elements = document.getElementsByClassName('slider-container');
        let container_parent = elements[0];
        if(container_parent) {
            container = document.createElement('div');
            container.id = id;
            container_parent.appendChild(container);
        }
    }

    return container;
}

export function createSeriesGrid(data, series_items, endpoint) {
    let series_name_div = document.createElement('div');
    series_name_div.className = "col-12 series-name";
    series_name_div.innerHTML = data.series;

    let grid_div = document.createElement('div');
    grid_div.className = "row row-cols-8  content-grid";
    grid_div.appendChild(series_name_div);

    $.each(series_items, function (index, attributes) {
        let tile_data_div = createSeriesItem(data, attributes, endpoint);
        grid_div.appendChild(tile_data_div);
    });

    return grid_div;
}

export function createSeriesSlider(data, series_items, endpoint, alternative_series_name) {
    let subseries_endpoint = endpoint == 'subseries';

    let slider_div = document.createElement('div');
    slider_div.className = "slick-slider carsoule left-align-slick";
    if(subseries_endpoint) {
        slider_div.className += " slick-slider-episode";
    }

    slider_div.id = "slick-slider-" + data['sort_order'];

    $.each(series_items, function (index, attributes) {
        let tile_data_div = createSeriesItem(data, attributes, endpoint);

        let series_item_inner = document.createElement('div');
        series_item_inner.appendChild(tile_data_div);

        let series_item = document.createElement('div');
        series_item.appendChild(series_item_inner);

        if (endpoint == 'top-content') {
            series_item = createTopContentItem(index, series_item);
        }
        slider_div.appendChild(series_item);
    });

    let slider_options = sliderOptionsFromEndpoint(endpoint);
    $(slider_div).slick(slider_options);


    let inner_series_div = document.createElement('div');
    inner_series_div.className = "row__inner";
    inner_series_div.appendChild(slider_div);

    let series_name_div = document.createElement('div');
    series_name_div.className = "row-fluid pull-left series-name";
    series_name_div.innerHTML = alternative_series_name ? alternative_series_name : data.series;

    let scroll_fade_div = document.createElement('div');
    scroll_fade_div.id = string_parameterize(data.series) + '-' + data.id;
    scroll_fade_div.className = "row-fluid scroll-fade";
    if(haveSeriesName(endpoint)) {
        scroll_fade_div.appendChild(series_name_div);
    }

    scroll_fade_div.appendChild(inner_series_div);

    return scroll_fade_div;
}

function logElementEvent(eventName, element) {
    console.log(Date.now(), eventName, element.getAttribute("data-src"));
}

export function initLazyLoading() {
    let lazyLoadInstances = [];

    let callback_enter = function (element) {
        // Instantiate a new LazyLoad on the element that entered
        let oneLL = new LazyLoad({
            container: element
        });
        // Optionally push it in the lazyLoadInstances
        // array to keep track of the instances
        lazyLoadInstances.push(oneLL);
        //logElementEvent("🔑 ENTERED", element);
    };

    let callback_exit = function (element) {
        logElementEvent("🚪 EXITED", element);
    };

    let callback_loading = function (element) {
        logElementEvent("⌚ LOADING", element);
    };

    let callback_loaded = function (element) {
        logElementEvent("👍 LOADED", element);
    };

    let callback_error = function (element) {
        logElementEvent("💀 ERROR", element);
        element.src =
            "https://d6ew5fw7x0406.cloudfront.net/covers/053ede1725b4a0996c3867ecc0fbb60865218592.jpg";
    };

    let callback_finish = function () {
        logElementEvent("✔️ FINISHED", document.documentElement);
    };

    let callback_cancel = function (element) {
        logElementEvent("🔥 CANCEL", element);
    };

    // The "lazyLazy" instance of lazyload is used
    // to check when the .horizContainer divs enter the viewport
    let lazyLazy = new LazyLoad({
        use_native: true,
        elements_selector: ".lazy",
        unobserve_entered: true, // <- To avoid executing the script multiple times
        // Assign the callbacks defined above
        callback_enter: callback_enter,
        /*
        callback_exit: callback_exit,
        callback_cancel: callback_cancel,
        callback_loading: callback_loading,
        callback_loaded: callback_loaded,
        callback_error: callback_error,
        callback_finish: callback_finish
        */
    });
}

export function initSliders() {
    const opts = { threshold: 0.1 };
    window.slick_slider_observer = new IntersectionObserver(handleSliderIntersection, opts);

    $.each(window.slick_slider_targets, function (index, target) {
        window.slick_slider_observer.observe(target);
    });

    $('.spinner-lsi').hide();
}

export function handleSliderIntersection(entries) {
    entries.map((entry) => {
        if (entry.isIntersecting) {
            /*
            console.log("INITIALIZE OBSERVABLE SLICK SLIDER");
            console.log(entry.target.id);
            console.log(entry.target.dataset['display']);
            console.log('--------------------------');
             */

            initSlickSliderItem(entry.target.id, entry.target.dataset['display'], entry.target.dataset['parent']);
            window.slick_slider_observer.unobserve(entry.target);
        }
    });
}

export function initSlickSliderItem(id, display, parent_id) {
    switch(display) {
        case 'landscape':
            $('#' + id).slick(Slider.SLICK_CATEGORIES_OPTIONS);
            break;
        case 'portrait':
            $('#' + id).slick(Slider.SLICK_OPTIONS);
            break;
        case 'count':
            $('#' + id).slick(Slider.SLICK_TOP_CONTENT_OPTIONS);
            break;
        default:
            $('#' + id).slick(Slider.SLICK_OPTIONS);
            break;
    }
    $('#' + parent_id).fadeTo(150,1);
}

function isInt(value) {
    var x;
    return isNaN(value) ? !1 : (x = parseFloat(value), (0 | x) === x);
}

export function haveSeriesName(endpoint) {
    return endpoint != 'similar-items' && !window.is_movie_details_page;
}

export function sliderOptionsFromEndpoint(endpoint) {
    switch(endpoint) {
        case 'top-content':
            return Slider.SLICK_TOP_CONTENT_OPTIONS;
        case 'subseries':
            return Slider.SLICK_SUBSERIES_OPTIONS;
        default:
            return Slider.SLICK_OPTIONS;
    }
}

export function createTopContentItem(index, series_item) {
    let number_div = document.createElement('div');
    number_div.className = "p2 top-number-background";
    number_div.dataset['fitText'] = null;
    let number = index + 1;
    let number_img_path = window.path_to_numbers["number" + number];
    number_div.style.backgroundImage = "url('" + number_img_path + "')";
    series_item.className = "p2 offset-tile"

    let top_content_div = document.createElement('div');
    top_content_div.className = "d-flex offset-tile-container";
    top_content_div.appendChild(number_div);
    top_content_div.appendChild(series_item);

    return top_content_div;
}

export function createSeriesItem(data, attributes, endpoint) {
    if (!window.first_item_id && ( window.is_home_page || window.is_category_page ) ) {
        let identifier = attributes['slug'] && attributes['slug'].length > 0 ? attributes['slug'] : attributes['id'];
        let jumbotron_options = {
            id: identifier,
            name: attributes['name'],
            kind: attributes['kind'],
            series: data.series,
            duration: formatDurationToHoursAndMinutes(attributes['duration']),
            screenshot: attributes['screenshot.expiring_url'],
            imdb: attributes['imdb'] ? attributes['imdb'] : null
        };

        FeaturedContent.updateJumbotronFeatured(jumbotron_options);
        window.first_item_id = attributes['id'];
    }

    let content_tile = new ContentTile( attributes, [ 'col', 'mb-2', 'mb-md-5' ] );
    return content_tile.element();
}

export function hmsToSecondsOnly(str) {
    var p = str.split(':'),
        s = 0, m = 1;

    while (p.length > 0) {
        s += m * parseInt(p.pop(), 10);
        m *= 60;
    }

    return s;
}

function hmsToMilisecondsOnly(str) {
    return hmsToSecondsOnly(str) * 1000;
}

export function calculateMovieProgress(duration, resume_time) {
    let movie_progress = 0;
    try {
        let watched_time = parseInt(resume_time);
        if(watched_time && watched_time > 0) {
            let duration_in_seconds = hmsToSecondsOnly(duration);
            movie_progress = (watched_time / duration_in_seconds) * 100;
        }
    } catch(e) {
        console.error('There was an error calculating episode progress');
        console.info('duration', duration);
        console.info('resume_time', resume_time);
        movie_progress = 0;
    }

    return Math.round(movie_progress);
}

export function formatDurationToHoursAndMinutes(duration_hms) {
    if(duration_hms) {
        let duration_splits = duration_hms.split(':');
        let hours =  isDurationGreaterThanAnHour(duration_splits)? (+duration_splits[0]) + "h " : ""
        let mins = isDurationLessThanAMinute(duration_splits) ? "1m" : (+duration_splits[1]) + "m";

        return hours + mins;
    }
    return;
}


function isDurationGreaterThanAnHour(duration_splits) {
    return duration_splits[0] !== "00";
}
function isDurationLessThanAMinute(duration_splits) {
    return duration_splits[0] === "00" && duration_splits[1] === "00" && duration_splits[2] && duration_splits[2] !== "00";
}

export function isInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

export function displaySpinner(){
    $('.modal-spinner').modal('show');
    setTimeout(function () {
        $('.modal-spinner').modal('hide');
    }, 6000);
}

export function switchAvatar(that) {
    let data = $(that).data();
    $('.profile-avatar-xl').attr("src", data.url);
    $('#user_avatar_id').val(data.value);
    $('#avatarsModal').modal('hide');
}

export function refreshPageAtInterval() {
    if(window.refresh_interval) {
        setTimeout(location.reload.bind(location), window.refresh_interval);
    }
}

export function initIntlTelInput() {
    if (window.init_iti) {
        // here, the index maps to the error code returned from getValidationError - see readme
        let errorMap = ["Invalid number", "Invalid country code", "Too short", "Too long", "Invalid number"];

        const input = document.querySelector(".processable-phone-number"),
            errorMsg = document.querySelector("#error-msg"),
            validMsg = document.querySelector("#valid-msg"),
            inputFeedback = document.querySelector("#phone_number_feedback");

        if(input) {
            // initialise plugin
            window.iti = intlTelInput(input,{
                initialCountry: 'US',
                separateDialCode: true,
                autoPlaceholder: 'aggressive',
                preferredCountries: ['US', 'CA', 'GB', 'AU', 'NZ', 'BR', 'MX', 'PH'],
                utilsScript: require('intl-tel-input/build/js/utils'),
            });

            let reset = function() {
                console.log('reset phone validation');
                if(window.is_checkout_page) {
                    input.classList.remove("is-valid");
                    input.classList.remove("is-invalid");
                    inputFeedback.innerHTML = '';
                } else {
                    input.classList.remove("error");
                    errorMsg.innerHTML = "";
                    errorMsg.classList.remove("d-block");
                    validMsg.classList.remove("d-block");
                    errorMsg.classList.add("d-none");
                    validMsg.classList.add("d-none");
                    $(inputFeedback).css('display', 'none');
                }
            };

            let validate = function() {
                reset();
                if (input.value.trim()) {
                    if (window.iti.isValidNumber()) {
                        console.log('phone is valid');
                        if(window.is_checkout_page) {
                            input.classList.add("is-valid");
                            inputFeedback.innerHTML = '';
                            $(inputFeedback).css('display', 'none');
                        } else {
                            validMsg.classList.remove("d-none");
                            validMsg.classList.add("d-block");
                            errorMsg.classList.remove("d-block");
                            errorMsg.classList.add("d-none");
                        }
                    } else {
                        console.log('phone is invalid');
                        var errorCode = window.iti.getValidationError();
                        console.log(errorMap[errorCode]);

                        if(window.is_checkout_page) {
                            input.classList.add("is-invalid");
                            inputFeedback.innerHTML = errorMap[errorCode];
                            $(inputFeedback).css('display', 'block');
                        } else {
                            input.classList.add("error");
                            validMsg.classList.remove("d-block");
                            validMsg.classList.add("d-none");
                            errorMsg.innerHTML = errorMap[errorCode];
                            errorMsg.classList.remove("d-none");
                            errorMsg.classList.add("d-block");
                        }
                    }
                } else {
                    console.log('phone is missing');
                    if(window.is_checkout_page) {
                        input.classList.add("is-invalid");
                        inputFeedback.innerHTML = 'Please enter phone number';
                        $(inputFeedback).css('display', 'block');
                    } else {
                        input.classList.add("error");
                        errorMsg.innerHTML = 'required';
                        validMsg.classList.remove("d-block");
                        validMsg.classList.add("d-none");
                        errorMsg.classList.remove("d-none");
                        errorMsg.classList.add("d-block");
                    }
                }

                if(window.uses_recurly || window.is_checkout_page) {
                    console.info('phone number', window.iti.getNumber());
                    let country_code = window.iti.selectedCountryData.iso2.toUpperCase();
                    console.log('updating country code to ' + country_code);
                    let $country_code_field = $('#country_code');
                    if($country_code_field) {
                        $('#country_code').val(country_code);
                    }

                    let $subregion_select_wrapper = $('#subregion_code_select');
                    let $subregion_select = $('#lsi-recurly-us-states');
                    let $subregion_input = $('#subregion_code');
                    if(country_code != 'US') {
                        console.log('needs subregion input box');
                        if($subregion_select) {
                            $subregion_select_wrapper.removeClass('d-block');
                            $subregion_select_wrapper.addClass('d-none');
                            $subregion_select.attr('required', false);
                        }

                        if($subregion_input) {
                            $subregion_input.removeClass('d-none');
                            $subregion_input.addClass('d-block');
                        }
                    } else {
                        console.log('needs subregion select box');
                        if($subregion_select) {
                            $subregion_select_wrapper.removeClass('d-none');
                            $subregion_select_wrapper.addClass('d-block');
                            $subregion_select.attr('required', true);
                        }

                        if($subregion_input) {
                            $subregion_input.removeClass('d-block');
                            $subregion_input.addClass('d-none');
                        }
                    }
                }
            }

            // on blur: validate
            input.addEventListener('keyup', validate);
            input.addEventListener('blur', validate);
            // on keyup / change flag: reset
            input.addEventListener('change', reset);
            //input.addEventListener('keyup', reset);
        }
    }
}

export function toggleUserInfoInputBoxes(that) {
    $('.account-info').hide();
    $('.account-info-fields').html('');

    let $user_info_elements = $('.account-info input, select, textarea');
    $user_info_elements.attr('disabled', true);
    $user_info_elements.attr('required', false);

    let data = $(that).data();
    let $selected_fields_elements = $('.account-info-' + data.fields + ' input, select, textarea');
    $selected_fields_elements.attr('disabled', false);
    $selected_fields_elements.attr('required', true);


    $('.account-info-fields').html(data.fields);
    $('.account-info-' + data['fields']).show();
    $('.account-info-optional input, select, textarea').attr('required', false);
}

export function string_parameterize(str1) {
    return str1.trim().toLowerCase().replace(/[^a-zA-Z0-9 -]/, "").replace(/\s/g, "-");
}

export function string_titleize(sentence) {
    //sentence.replace(/[^a-zA-Z0-9 -]/, "").replace(/\s/g, "-");
    if(!sentence.split) return sentence;
    var _titleizeWord = function(string) {
            return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
        },
        result = [];
    sentence.split(" ").forEach(function(w) {
        result.push(_titleizeWord(w));
    });
    return result.join(" ");
}

export function otherJQueryInitializations() {
    window.$ = window.jQuery = require("jquery");
    window.$.event.special.touchstart = {
        setup: function( _, ns, handle ){
            this.addEventListener("touchstart", handle, { passive: true });
        }
    };

    $.ajaxSetup({
        headers: {
            'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
        }
    });
}

export function startSpinnerInButton(that) {
    let $spinnable_button = $(that);
    window.spinning_button_html = $spinnable_button.html();
    window.spinning_button_value = $spinnable_button.val();
    if(window.spinning_button_value) {
        $spinnable_button.val("loading...", true);
    }

    if(window.spinning_button_html) {
        $spinnable_button.html(
            `<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Loading...`
        );
    }

    $spinnable_button.prop("disabled", true);
    $spinnable_button.addClass('spinning-button');
}

export function stopSpinnerInButton() {
    let $spinning_button = $(".spinning-button")
    if(window.spinning_button_html) {
        $spinning_button.html(window.spinning_button_html);
    }

    if(window.spinning_button_value) {
        $spinning_button.val(window.spinning_button_value);
    }

    $spinning_button.prop("disabled", false);
    $spinning_button.removeClass('spinning-button');
}

export function checkForAjaxFormSubmission() {
    $("form").on("submit", function(event){
        let $form = $(this);
        let data_obj = $form.data();
        if (data_obj && data_obj.remote) {
            event.preventDefault();
            setTimeout(function(){
                $.ajax({
                    url     : $form.attr('action'),
                    type    : data_obj.method,
                    dataType: 'json',
                    data    : $form.serializeArray(),
                    success : function(data) {
                        console.log(data);
                    },
                    error   : function(xhr, err) {
                        console.log(xhr.status);
                        console.log(xhr.statusText);
                        console.log(xhr.responseText);
                        console.log(err);
                    }
                });
                stopSpinnerInButton();
            }, 500);
        }
    });
}


function reachedTop() {
    let top_of_page = document.getElementById('featured-info-detail');
    if (!top_of_page) {
        top_of_page = document.getElementById('top-of-page');
    }

    return top_of_page && isInViewport(top_of_page);
}

export function goToClosest() {
    if (window.smart_scroll_ready) {

        var loaders = document.getElementsByClassName('series-scroll-loader');
        if (loaders.length > 0) {
            console.log(loaders.length);
            console.log(loaders[loaders.length-1])
            let loader = loaders[loaders.length-1];
            if (loader) {
                console.log(loader.dataset.page);
                let page = loader.dataset.page;
                if(page) {
                    setTimeout(function () {
                        let container = document.getElementById('series-' + page + '-' + window.catalog_params_meta_page_size);
                        if(container && !container.innerHTML) {
                            loadContentPre();
                            console.log('loading next series!');
                        } else {
                            console.log('not loading, there is something there');
                        }

                    }, 5000);
                }
            } else {
                console.log('no scrolling to loader! not found');
            }
        } else {
            console.log('no loaders found!');
        }
    }
}

export function hideOrDisplayNavbar(that) {
    if (window.smart_scroll_ready) {
        let reached_top = reachedTop();
        if (reached_top) {
            $('.smart-scroll').removeClass('scrolled');
        } else {
            $('.smart-scroll').addClass('scrolled');
        }

        let scroll_top = $(that).scrollTop();
        let $flash_messages = $('.flash-messages-container');
        if(scroll_top < window.last_scroll_top) {
            $('.smart-scroll').removeClass('scrolled-down').addClass('scrolled-up');
            $flash_messages.css('margin-top', '50px');
        }
        else {
            if(!reached_top) {
                $('.smart-scroll').removeClass('scrolled-up').addClass('scrolled-down');
                $flash_messages.css('margin-top', '0');
            }
        }
        window.last_scroll_top = scroll_top;
    } else {
        window.smart_scroll_ready = true;
    }
}

export function loadNextCatalogPage(that) {
    if(isInViewport(that) && that.dataset && that.dataset.page) {
        let page = that.dataset.page;
        if (!window.catalog_processing_pages.includes(page)) {
            window.catalog_processing_pages.push(page);
            let page_not_loaded = !window.catalog_loaded_pages.includes(page);
            if(page_not_loaded) {
                displayLoadedSeriesNotification("catalog page " + page);
                let regular_content_options = { endpoint: null, page: page, page_size: window.catalog_params_meta_page_size };
                getCatalogPage(regular_content_options);
                if (page == window.catalog_page_count) {
                    setTimeout(function () {
                        displayLoadedSeriesNotification(null);
                    }, 2000);

                    $('.spinner-lsi').hide();
                }
            }
        }
    }
}

export function displayModalMessage(message, color_class, timeout_ms) {

    let alert = document.getElementById('modal-notification-alert');
    alert.className = "alert alert-" + color_class;

    $('.modal-notification-content').html(message);

    openFeedback('#modal-notification');

    let $modal_backdrop = $('.modal-backdrop');
    $modal_backdrop.removeClass("modal-backdrop");

    if(timeout_ms) {
        setTimeout(function () {
            closeModal('#modal-notification');
            $modal_backdrop.removeClass("modal-backdrop");
        }, timeout_ms);
    }
}

export function displayLoadedSeriesNotification(series) {
    if(window.display_loaded_series) {
        let status = !series ? '<strong>All series loaded!</strong>' : 'Now loading:' + '<br/><strong>' + series + '</strong>';
        displayModalMessage(
            window.catalog_loaded_series + ' series loaded!<br/>' + status,
            'success',
            4000
        );
    }
}

function openFeedback(selector, color_class) {
    $(selector + '.modal-body').addClass(color_class);
    $(selector).modal('show');
}

function closeModal(selector) {
    $(selector).modal('hide');
}

export function registerLoadedPage(page) {
    window.catalog_loaded_pages.push(page);
    window.catalog_loaded_pages.sort();
    window.catalog_all_loaded = window.catalog_loaded_pages.filter(distinct).length == window.catalog_page_count;
}

export function registerLoadedSeries() {
    window.catalog_loaded_series += 1;
}

export function togglePasswordField(that, toggle_eye=true, change_text=null) {
    let $link = $(that)
    let $input = $link.parent().parent().parent().find('input');
    if($input) {
        let input_type = $input.attr("type");
        if(input_type == "text" || input_type == "number"){
            $input.attr('type', 'password');
            if ( toggle_eye ) {
                $link.html('<ion-icon name="eye"></ion-icon>');
            } else if( change_text && change_text.off ) {
                $link.html('<small>' + change_text.off + '</small>');
            }

        }else if(input_type == "password"){
            let input_id = $input.attr('id');
            if (input_id && input_id.includes('pin')) {
                $input.attr('type', 'number');
            } else {
                $input.attr('type', 'text');
            }

            if ( toggle_eye ) {
                $link.html('<ion-icon name="eye-off"></ion-icon>');
            } else if( change_text && change_text.on ) {
                $link.html('<small>' + change_text.on + '</small>');
            }

        }
    }
}

export function updateGridBackground() {
    $('.main-container-grid').css('background-image', 'url(' + window.jumbotron_background.latest +'), url(' + window.jumbotron_background.previous +')');
}

export function populateSortByLetter() {
    let letters_container = document.getElementById("letters-container");
    let letters = document.querySelectorAll('[data-letter]');
    if(letters_container && letters) {
        let initials = [];
        for(let idx in letters) {
            let data = letters[idx].dataset
            if (data) {
                let initial = data["letter"].trim();
                if (initial && initial.length === 1 && !initials.includes(initial)) {
                    initials.push(initial);
                    let link = document.createElement('a');
                    link.id= "sortable-letter" + initial;
                    link.href = "javascript: void(0)";
                    link.classList.add("btn");
                    link.classList.add("btn-outline-light");
                    link.classList.add("btn-sm");
                    link.classList.add("sortable-letter");
                    link.innerText = initial;
                    link.dataset['letter'] = initial;
                    letters_container.appendChild(link);
                }
            }
        }
    }
}

export function sortByLetter(initial) {
    let active_initial = document.querySelector('#letters-container .active');
    if (active_initial) {
        active_initial.classList.remove('active');
    }

    let new_active_initial = document.querySelector('#sortable-letter' + initial);
    new_active_initial.classList.add('active');

    let elements = document.querySelectorAll('.letter-sort');
    for (let idx in elements) {
        if (elements[idx].style) {
            elements[idx].style.display = 'inline-block';
            if ( initial != 'All') {
                let data = elements[idx].dataset
                if (data && data["letter"] && data["letter"] != initial) {
                    elements[idx].style.display = 'none';
                }
            }
        }
    }
}

export function limitText(field, maxChar){
    var ref = $(field),
        val = ref.val();
    if ( val.length >= maxChar ){
        ref.val(function() {
            return val.substr(0, maxChar);
        });
    }
}

export function initLockedMovieModal() {
    $("#lockedMovieModal").on("show", function () {
        $("body").addClass("modal-open");
    }).on("hidden", function () {
        $("body").removeClass("modal-open")
    });
}

export function closeLockedModal() {
    $( '.close' ).click();
}

export function displayLockedModal() {
    $( "#lockedMovieModal" ).modal( { backdrop: 'static', keyboard: false } );
}

export function errorsFromRecurlyFieldsArray(fields) {
    let errors = [];
    if( fields.length > 0 ) {
        for( var i in fields ) {
            switch( fields[i] ) {
                case 'number':
                    errors.push( " Invalid credit card number" );
                    break;
                case 'month':
                    errors.push( " Invalid credit card expiration month" );
                    break;
                case 'year':
                    errors.push( " Invalid credit card expiration year" );
                    break;
                default:
                    errors.push( fields[i] );
                    break;
            }
        }
    }

    return errors;
}

export const distinct = (value, index, self)  => {
    return self.indexOf(value) === index;
};

export function sortAndFilterUnique(data) {
    return data.sort((a, b) => (a.sort_order > b.sort_order) ? 1 : -1).filter(distinct);
}

(function ($) {
    $.event.special.load = {
        add: function (hollaback) {
            if ( this.nodeType === 1 && this.tagName.toLowerCase() === 'img' && this.src !== '' ) {
                // Image is already complete, fire the hollaback (fixes browser issues were cached
                // images isn't triggering the load event)
                if ( this.complete || this.readyState === 4 ) {
                    hollaback.handler.apply(this);
                }

                // Check if data URI images is supported, fire 'error' event if not
                else if ( this.readyState === 'uninitialized' && this.src.indexOf('data:') === 0 ) {
                    $(this).trigger('error');
                }

                else {
                    $(this).bind('load', hollaback.handler);
                }
            }
        }
    };
}(jQuery));

function objectDetailPath(object) {
    switch(object['kind']) {
        case 'movie':
            return "/movies/" + object['slug'];
        case 'subseries':
            return "/series/" + object['slug'];
        case 'collection':
            return "/categories/" + object['id'];
        default:
            return '#';
    }
}
